var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 27.5H13.25C10.775 27.5 8.75 25.475 8.75 23V17C8.75 14.525 10.775 12.5 13.25 12.5H26.75C29.225 12.5 31.25 14.525 31.25 17V23C31.25 25.475 29.225 27.5 26.75 27.5Z",
    fill: "#C2191E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23.75V16.25L24.5 20L17 23.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial4);
export default __webpack_public_path__ + "static/media/Social-4.a681a7540275027dd604889014348d1e.svg";
export { ForwardRef as ReactComponent };